<template lang="html">
  <div class="admin-portal-users-container">
    <div>
      <admin-portal-users-top-bar
        :licenseDetails="licenseDetails"
        :licensesUsed="licensesUsed"
      />
    </div>
    <div v-if="emailSuffixes && emailSuffixes.length" class="pl-subheading mb3">
      Approved email suffixes:
      <span v-for="(email_suffix, index) in emailSuffixes">
        {{
          index + 1 !== emailSuffixes.length
            ? email_suffix + ',&nbsp;'
            : email_suffix
        }}
      </span>
    </div>
    <div>
      <admin-portal-users-filters-bar
        :schoolSites="school_sites"
        @parlay-users-filter-changed="resetFilters"
        @filters="searchAndFilters"
        @getTrialTeachers="showTrialTeachers"
        @getUsers="showUsers"
      />
    </div>
    <div>
      <admin-portal-users-table
        :loading="loading"
        :usersList="usersList"
        :schoolUsersCount="schoolUsersCount"
        :schoolUsersCountLoaded="schoolUsersCountLoaded"
        :trialTeachers="trialTeachers"
        :schoolSites="school_sites"
        @scroll-on-table="handleScroll(page_number)"
      />
    </div>
    <div class="row w-100 center-xs">
      <div v-if="loading_table_body">
        <pl-spinner class="x5" />
      </div>
    </div>
  </div>
</template>

<script>
  import adminPortalUsersFiltersBar from 'features/admin/adminPortal/adminPortalUsers/adminPortalUsersFiltersBar.vue';
  import adminPortalUsersTopBar from 'features/admin/adminPortal/adminPortalUsers/adminPortalUsersTopBar.vue';
  import adminPortalUsersTable from 'features/admin/adminPortal/adminPortalUsers/adminPortalUsersTable.vue';
  import Vue from 'vue';
  import adminServices from 'services/admin/adminServices';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      adminPortalUsersTopBar,
      adminPortalUsersFiltersBar,
      adminPortalUsersTable,
    },
    data() {
      return {
        user_search: '',
        email_search: '',
        subjects_search: [],
        userType_search: 'teacher',
        loading: false,
        schools_search: [],
        subjectsList: [],
        usersList: [],
        trialTeachers: [],
        page_number: 1,
        show_more_users: true,
        loading_table_body: false,
        users_page_size: 20,
        filters: {
          name: '',
          email: '',
          subjects_ids: [],
          roles: 'teacher',
          page: 1,
        },
        show_trial_teachers: false,
        school_sites: [],
        schoolUsersCount: 0,
        schoolUsersCountLoaded: 0,
      };
    },
    computed: {
      ...mapGetters(['getCurrentSchool', 'getProfile']),
      licenseDetails() {
        return this.usersList.length;
      },
      licensesUsed() {
        return this.usersList.length;
      },
      emailSuffixes() {
        if (this.getCurrentSchool.invites) {
          const [invite] = this.getCurrentSchool.invites;

          if (invite && invite.email_suffixes) {
            return invite.email_suffixes;
          }
        }

        return [];
      },
      hasAdminPermission() {
        if (this.getProfile.role === 'admin') {
          return true;
        } else if (this.getProfile && this.getProfile.school) {
          return (
            this.$router.currentRoute.params.schoolID ===
              this.getProfile.school.school_id &&
            (this.getProfile.school.admin_role === 'admin' ||
              this.getProfile.school.admin_role === 'coach')
          );
        } else {
          return false;
        }
      },
    },
    methods: {
      getUsersFromSchoolID(page, is_filter, onScroll) {
        if (!onScroll) {
          this.loading = true;
        } else {
          this.loading_table_body = true;
        }

        if (is_filter) {
          this.usersList = [];
        }

        this.filters.page = page;
        this.filters.roles =
          this.filters.roles === 'all' ? null : this.filters.roles;

        adminServices
          .getUsersOfSchool(this.$route.params.schoolID, this.filters)
          .then(({ data }) => {
            if (data && data.school_users.length > 0) {
              if (this.page_number === 1) {
                this.schoolUsersCount = data.school_users_count;
              }
              this.schoolUsersCountLoaded = data.school_users_count_loaded;
              let users_loaded = [];
              if (data.school_users && data.school_users.length) {
                users_loaded = data.school_users;
                users_loaded.forEach((itm) =>
                  this.$set(itm, 'selected', false)
                );
              }
              this.usersList.push(...users_loaded);

              if (data.school_users.length === this.users_page_size) {
                this.page_number += 1;
              } else {
                this.show_more_users = false;
              }
            } else {
              this.show_more_users = false;
            }
          })
          .catch((error) => {
            console.log(error);
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
          })
          .finally(() => {
            this.loading = false;
            this.loading_table_body = false;
          });
      },
      getTrialTeachers(page, is_filter, onScroll) {
        if (!onScroll) {
          this.loading = true;
        } else {
          this.loading_table_body = true;
        }

        if (is_filter) {
          this.trialTeachers = [];
        }
        this.filters.page = page;
        adminServices
          .getTrialTeachers(this.$route.params.schoolID, this.filters)
          .then(({ data }) => {
            if (data && data.length > 0) {
              this.trialTeachers.push(...data);
              if (data.length === this.users_page_size) {
                this.page_number += 1;
              } else {
                this.show_more_users = false;
              }
            } else {
              this.show_more_users = false;
            }
          })
          .catch((error) => {
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
            this.loading_table_body = false;
          });
      },
      loadSubjects() {
        return this.$store.dispatch('getAllSubjects').then((results) => {
          this.subjectsList = results;
        });
      },
      removeUsersOfSchoolFromTable(usersId) {
        const resultList = this.usersList.filter((u) => {
          return !this.userIsOnTheList(u, usersId);
        });
        const trialUsers = this.usersList.filter((u) => {
          return this.userIsOnTheList(u, usersId);
        });
        this.usersList = resultList;
        trialUsers.forEach((user) => {
          if (user.role === 'teacher') {
            this.trialTeachers.push(user);
          }
        });
        this.schoolUsersCount -= usersId.length;
      },
      userIsOnTheList(u, usersId) {
        if (usersId && usersId.length > 0) {
          return usersId.includes(u.id);
        } else {
          return false;
        }
      },
      updateUserRoleEvent() {
        EventBus.$on('update-user-role-event', (user) => {
          const index = this.usersList.findIndex((u) => u.id === user.id);
          if (index > -1) {
            Vue.set(this.usersList[index], 'role', user.role);
          }
        });
      },
      updateUserAdminRoleEvent() {
        EventBus.$on('update-user-admin-role-event', (user) => {
          this.usersList.map((itm) => {
            if (itm.id === user.id) {
              return (itm.admin_role = user.user_school[0].admin_role);
            }
          });
        });
      },

      updateUserSchoolSiteEvent() {
        EventBus.$on('update-user-school-site-event', (user) => {
          this.usersList.map((itm) => {
            if (itm.id === user.id) {
              return (itm.school_site = user.schoolSite.name);
            }
          });
        });
      },

      resetFilters() {
        this.userList = [];
        this.trialTeachers = [];
        this.show_more_users = true;
        this.page_number = 1;
      },

      searchAndFilters(value) {
        this.filters = value.filters;
        this.show_trial_teachers = value.trial_teachers;
        if (value.trial_teachers) {
          this.getTrialTeachers(this.page_number, true);
        } else {
          this.getUsersFromSchoolID(this.page_number, true);
        }
      },

      showTrialTeachers() {
        this.resetFilters();
        this.show_trial_teachers = true;
        this.getTrialTeachers(this.page_number, true);
      },
      showUsers() {
        this.resetFilters();
        this.show_trial_teachers = false;
        this.getUsersFromSchoolID(this.page_number, true);
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);
        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll(page_number) {
        if (
          this.elementHasReachedScrollEnd('admin-portal-users-table') &&
          this.show_more_users
        ) {
          if (this.show_trial_teachers) {
            this.getTrialTeachers(this.page_number, false, true);
          } else {
            this.getUsersFromSchoolID(page_number, false, true);
          }
        }
      },
      loadSitesOfSchool() {
        const school_id = this.$route.params.schoolID;
        this.$store
          .dispatch('getSitesOfSchool', school_id)
          .then((results) => (this.school_sites = results));
      },
    },
    created() {},
    mounted() {
      if (!this.hasAdminPermission) {
        this.$router.push({ name: 'dashboard' });
        EventBus.$emit('toast-msg', `You don't have access to this page.`);
      } else {
        this.getUsersFromSchoolID(this.page_number, true);

        EventBus.$on('remove-users-of-school-from-table', (usersId) => {
          this.removeUsersOfSchoolFromTable(usersId);
        });
        EventBus.$on('updateUsersList', () => {
          this.getUsersFromSchoolID(this.page_number, true);
        });
        EventBus.$on('updateUsersListAfterRemove', () => {
          this.page_number = 1;
          this.getUsersFromSchoolID(this.page_number, true);
        });
        EventBus.$on('upgraded-teacher', (user) => {
          const index = this.trialTeachers.findIndex((u) => u.id === user.id);
          if (index > -1) {
            this.trialTeachers.splice(index, 1);
          }
          this.usersList.push(user);
        });

        // events from userDetailsModal
        this.updateUserRoleEvent();
        this.updateUserAdminRoleEvent();
        this.updateUserSchoolSiteEvent();

        this.loadSitesOfSchool();
      }
    },
    beforeDestroy() {
      EventBus.$off('upgraded-teacher');
      EventBus.$off('updateUsersList');
      EventBus.$off('updateUsersListAfterRemove');
      EventBus.$off('remove-users-of-school-from-table');
      // events from userDetailsModal
      EventBus.$off('update-user-role-event');
      EventBus.$off('update-user-admin-role-event');
      EventBus.$off('update-user-school-site-event');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .admin-portal-users-container{
    padding: 1rem 2rem 0 2rem
  }
</style>



// WEBPACK FOOTER //
// adminPortalUsers.vue?fcbffc4c